import Icon from '@ant-design/icons'
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

// 取消归档
/* eslint-disable */
const Svg = () => (
  // eslint-disable-next-line
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none">
    <path d="M10.0168 4.03125L15.0012 7.60937V16.25H12.5012V11.25H7.50116V16.25H5.00116V7.60937L10.0168 4.03125ZM10.0168 2.64062C9.89178 2.64062 9.76678 2.67188 9.65741 2.75L2.03241 8.1875C1.78241 8.35937 1.90741 8.75 2.21991 8.75H3.75116V17.1875C3.75116 17.3594 3.89178 17.5 4.06366 17.5H8.43866C8.61053 17.5 8.75116 17.3594 8.75116 17.1875V12.5H11.2512V17.1875C11.2512 17.3594 11.3918 17.5 11.5637 17.5H15.9387C16.1105 17.5 16.2512 17.3594 16.2512 17.1875V8.75H17.7824C18.0793 8.75 18.2043 8.35937 17.9699 8.1875L10.3762 2.76563C10.2668 2.6875 10.1418 2.64062 10.0168 2.64062Z" fill="url(#paint0_linear_3444_14413)" />
    <defs>
      <linearGradient id="paint0_linear_3444_14413" x1="1.89941" y1="10.0703" x2="18.0921" y2="10.0703" gradientUnits="userSpaceOnUse">
        <stop stopColor="#0CB6FF" />
        <stop offset="1" stopColor="#288EFF" />
      </linearGradient>
    </defs>
  </svg>

)

const IconComponent = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={Svg} {...props} />
)

export default IconComponent
